import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    color: '#f64444',
    cursor: 'default',
    marginTop: '0.625rem',
  },
  warningText: {
    marginLeft: '0.5rem',
  },
}));
